// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__16g3C","pencil":"IconEdit_pencil__kEmH1"};